import { registerCondition } from 'core/forms';

const isTriggerNotStartDate = ({ model }) => ({
  condition: null,
  hasCondition: model.type !== 'LetterTriggerStartDate',
});

registerCondition('isTriggerNotStartDate', isTriggerNotStartDate);

export default isTriggerNotStartDate;
